import React, { useRef } from "react";
import Input from "./Input/Input";
import Button from "./button/Button";
import sendIconWhite from "../../assets/icons/send-icon-white.png";
import useToast from "./Toast/useToast";

function SubscribeToNewsletter() {

  const inputRef = useRef();

  const handleSubmit = (e) => {
    e.preventDefault();
    console.log('::: input', inputRef.current.value);

    const formData = new FormData();
    formData.append('email', inputRef.current.value);

    fetch("https://script.google.com/macros/s/AKfycbzQu34KINyoXgCD4a1zZuf9r0YyOZuZlzcKxnS10veNwZvfjQNJ2Y9OmXb30gZTHqir5g/exec",
      { method: 'POST', body: formData })
      .then(res => {
        console.log("SUCCESSFULLY SUBMITTED")
      })
      .catch(err => console.log(err))
  };

  return (
    <form onSubmit={handleSubmit} name="subscribe-newsletter">
      <div className="flex items-center flex-col lg:flex-row justify-start">
        <Input inputRef={inputRef} id="email" name="email" className="w-[100%] lg:w-[350px] mb-[16px] lg:mb-0" required />
        <Button
          htmlType="submit"
          title="Subscribe"
          icon={sendIconWhite}
          className="lg:ml-2 w-3/4 sm:w-3/6 lg:w-[200px]"
        />
      </div>
    </form>
  );
}

export default SubscribeToNewsletter;
